<app-banner></app-banner>

<section class="main-section register white-bg">
    <div class="width-container">
        <h2 [innerHtml]="'REGISTER.HEAD' | translate:data"></h2>
        <p [innerHtml]="'REGISTER.DESC' | translate:data"></p>
    </div>
</section>
<section class="main-section form-section">
    <div class="width-container">
        <h2 [innerHtml]="'FORM.HEAD' | translate:data"></h2>
        <app-form></app-form>
    </div>
</section>